import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { SearchCustomerIsActiveOptions } from 'modules/shared/models/filter.models';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var CustomerService = /** @class */ (function () {
    function CustomerService(httpClient) {
        this.httpClient = httpClient;
        this.apiBase = environment.API_BASE;
    }
    CustomerService.prototype.getCustomer = function (id) {
        return this.httpClient.get(this.apiBase + "/api/customers/" + id + "/");
    };
    CustomerService.prototype.getCustomers = function (payload) {
        var url = this.apiBase;
        url += '/api/customers/?';
        url += "" + (payload.limit ? "&limit=" + payload.limit : '');
        url += "" + (payload.offset ? "&offset=" + payload.offset : '');
        url += "" + (payload.sort ? "&sort=" + payload.sort : '');
        url += "" + (payload.name ? "&name=" + payload.name : '');
        url += "" + (payload.searchStatus ? "&search_status=" + payload.searchStatus : '');
        url += "" + (payload.searchIntegrationStatus ? "&integration_status=" + payload.searchIntegrationStatus : '');
        url += "" + (payload.active ? "&is_active_customer=" + ((payload.active.toUpperCase() === SearchCustomerIsActiveOptions['ACTIVE']) ? 'true' : 'false') : '');
        url += "" + (payload.recordType ? "&record_type=" + payload.recordType.toUpperCase() : '');
        url += "" + (payload.searchAll ? "&search_all=" + payload.searchAll : '');
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getCustomersExtended = function (customersReqBody) {
        var params = new HttpParams();
        var url = this.apiBase + '/api/customers/';
        if (customersReqBody) {
            var reqBodyEntries = Object.entries(customersReqBody);
            reqBodyEntries.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (value !== undefined) {
                    params = params.append(key, value);
                }
            });
        }
        return this.httpClient.get(url, { params: params });
    };
    CustomerService.prototype.getCustomersBatchUploads = function (customersReqBody) {
        var params = new HttpParams();
        var url = this.apiBase + '/api/customers/bulk_create/';
        if (customersReqBody) {
            var reqBodyEntries = Object.entries(customersReqBody);
            reqBodyEntries.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (value !== undefined) {
                    params = params.append(key, value);
                }
            });
        }
        return this.httpClient.get(url, { params: params });
    };
    CustomerService.prototype.getCustomersBatchUploadTemplate = function () {
        var url = this.apiBase + "/api/customers/bulk_create_template/";
        return this.httpClient.get(url, {
            responseType: 'blob'
        });
    };
    CustomerService.prototype.getCrp = function (crpId) {
        var url = this.apiBase + "/api/crps/" + crpId + "/";
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getRelatedCrp = function (recordId) {
        var url = this.apiBase + "/api/records/" + recordId + "/crps/";
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getCustomerCrps = function (payload) {
        var url = this.apiBase + "/api/customers/" + payload.customerId + "/crps/?";
        url += "" + (payload.limit ? "limit=" + payload.limit : '');
        url += "" + (payload.offset ? "&offset=" + payload.offset : '');
        url += "" + (payload.search ? "&search=" + payload.search : '');
        url += "" + (payload.sort ? "&sort=" + payload.sort : '');
        if (!payload.primary) {
            url += "&primary=" + payload.primary;
        }
        if (payload.searchName) {
            url += "&name=" + payload.searchName;
        }
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getDocuments = function (payload) {
        var url = this.apiBase + "/api/records/" + payload.id + "/documents/?";
        url += "" + (payload.limit ? "limit=" + payload.limit : '');
        url += "" + (payload.type ? "&doc_type=" + payload.type : '');
        url += "" + (payload.offset ? "&offset=" + payload.offset : '');
        url += "" + (payload.sort ? "&sort=" + payload.sort : '');
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getCsv = function () {
        var url = this.apiBase + "/api/customers/csv/";
        return this.httpClient.get(url, {
            responseType: 'json'
        });
    };
    CustomerService.prototype.getOnboardingModes = function () {
        return this.httpClient.get(this.apiBase + "/api/customers/onboarding_modes/");
    };
    CustomerService.prototype.getProfileTypes = function () {
        return this.httpClient.get(this.apiBase + "/api/customers/profile_types/");
    };
    CustomerService.prototype.getPaymentModes = function () {
        return this.httpClient.get(this.apiBase + "/api/customers/payment_modes/");
    };
    CustomerService.prototype.getProductComplexities = function () {
        return this.httpClient.get(this.apiBase + "/api/customers/product_service_complexities/");
    };
    CustomerService.prototype.getCrpsRole = function () {
        return this.httpClient.get(this.apiBase + "/api/crps/roles/");
    };
    CustomerService.prototype.getUsers = function (payload) {
        var url = this.apiBase + "/api/users/?";
        url += "" + (payload.limit ? "limit=" + payload.limit : '');
        url += "" + (payload.offset ? "&offset=" + payload.offset : '');
        if (payload.domain) {
            url += "&domain=" + payload.domain;
        }
        if (payload.searchName) {
            url += "&name=" + payload.searchName;
        }
        if (payload.roles) {
            url += "&roles=" + payload.roles;
        }
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getEntityTypes = function () {
        var url = this.apiBase;
        url += '/api/corporate_records/entity_types/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getOwnershipLayers = function () {
        var url = this.apiBase;
        url += '/api/corporate_records/ownership_layers/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getCountries = function () {
        var url = this.apiBase;
        url += '/api/records/countries/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getSsoc = function () {
        var url = this.apiBase;
        url += '/api/individual_records/ssoc/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getIdTypes = function () {
        var url = this.apiBase;
        url += '/api/individual_records/id_types/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getTitles = function () {
        var url = this.apiBase;
        url += '/api/individual_records/titles/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getSourceOfFunds = function () {
        var url = this.apiBase;
        url += '/api/records/source_of_funds/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getSsic = function () {
        var url = this.apiBase;
        url += '/api/records/ssic/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getProductServiceComplexities = function () {
        var url = this.apiBase;
        url += '/api/customers/product_service_complexities/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getGenders = function () {
        var url = this.apiBase;
        url += '/api/individual_records/gender/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getStatuses = function () {
        var url = this.apiBase;
        url += '/api/crps/status/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getSourceOfWealth = function () {
        var url = this.apiBase;
        url += '/api/customers/source_of_wealth/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getAnnualIncomeLevelUsd = function () {
        var url = this.apiBase;
        url += '/api/customers/annual_income_level/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.getAppConfig = function () {
        var url = this.apiBase;
        url += '/api/appconfig/AVAILABLE_FORM_FIELDS/';
        return this.httpClient.get(url);
    };
    CustomerService.prototype.createOrUpdateCustomer = function (createOrUpdateCustomerPayload) {
        var _this = this;
        var url = this.apiBase;
        if (createOrUpdateCustomerPayload.customerData.individualRecords &&
            createOrUpdateCustomerPayload.customerData.individualRecords.length) {
            createOrUpdateCustomerPayload.customerData.individualRecords.map(function (individualRecord) {
                return _this.deleteNullContent(individualRecord);
            });
        }
        if (createOrUpdateCustomerPayload.customerData.corporateRecords &&
            createOrUpdateCustomerPayload.customerData.corporateRecords.length) {
            createOrUpdateCustomerPayload.customerData.corporateRecords.map(function (individualRecord) {
                return _this.deleteNullContent(individualRecord);
            });
        }
        if (createOrUpdateCustomerPayload.mode === 'CREATE') {
            url += '/api/customers/';
            return this.httpClient.post(url, this.deleteNullContent(createOrUpdateCustomerPayload.customerData));
        }
        else {
            url += "/api/customers/" + createOrUpdateCustomerPayload.customerId + "/";
            return this.httpClient.patch(url, this.deleteNullContent(createOrUpdateCustomerPayload.customerData));
        }
    };
    CustomerService.prototype.patchCustomer = function (payload) {
        var url = this.apiBase + "/api/customers/" + payload.id + "/";
        return this.httpClient.patch(url, payload);
    };
    CustomerService.prototype.deleteNullContent = function (object) {
        for (var i in object) {
            if (object[i] === null &&
                ['idExpiryDate', 'idIssueDate', 'dateOfBirth', 'incorporationDate', 'incorporationExpiryDate'].indexOf(i) < 0) {
                object[i] = '';
            }
        }
        return object;
    };
    CustomerService.prototype.createRiskReports = function (customerId) {
        return this.httpClient.post(this.apiBase + "/api/customers/" + customerId + "/risk_reports/", {});
    };
    CustomerService.prototype.downloadReport = function (customerId) {
        var url = this.apiBase + "/api/customers/" + customerId + "/pdf_report/";
        return this.httpClient.get(url, {
            responseType: 'blob'
        });
    };
    CustomerService.prototype.downloadAcceptanceForm = function (customerId) {
        var url = this.apiBase + "/api/customers/" + customerId + "/acceptance_form/";
        return this.httpClient.get(url, {
            responseType: 'blob'
        });
    };
    /**
     * Returns a list of periodic review
     * @method loadPeriodicReview
     */
    CustomerService.prototype.loadPeriodicReview = function (payload) {
        var params = new HttpParams();
        var url = this.apiBase;
        url += '/api/customers/periodic_reviews/?';
        if (payload) {
            Object.entries(payload).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (value !== undefined) {
                    params = params.append(key, value);
                }
            });
        }
        return this.httpClient.get("" + url, { params: params });
    };
    /**
     * Delete a customer
     * @method deleteCustomer
     */
    CustomerService.prototype.deleteCustomer = function (customerId) {
        return this.httpClient.delete(this.apiBase + "/api/customers/" + customerId + "/", { observe: 'response' });
    };
    CustomerService.prototype.uploadCustomersBatchFile = function (params) {
        var url = this.apiBase + '/api/customers/bulk_create/';
        var form = new FormData();
        form.append('file', params.file);
        params.users.forEach(function (user) {
            form.append('users', user);
        });
        params.domains.forEach(function (domain) {
            form.append('domains', domain);
        });
        return this.httpClient.post(url, form);
    };
    CustomerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CustomerService_Factory() { return new CustomerService(i0.ɵɵinject(i1.HttpClient)); }, token: CustomerService, providedIn: "root" });
    return CustomerService;
}());
export { CustomerService };
